import React, { useState, useEffect, useRef } from 'react';
import {
  getQuotationRequest,
  getSinglePurchaseOrder,
  getVehicleRequest,
  createRunningVehicle,
  updateStatusRunningVehicle,
  updateStatusPurchaseOrder,
  getSinglePurchaseOrderReport,
} from '../../services/vm/apiController';
import { destroy } from '../../services/apiController';
import { Link, useParams, useNavigate } from 'react-router-dom';
import { formatDate } from '../../util/helper';
import { DeleteIcon, DownloadIcon } from './components/icons';
import { toast, ToastContainer } from 'react-toastify';
import { Row, Col, Modal, Button, Form, FloatingLabel } from 'react-bootstrap';
import '../../style/switch.css';
import AlertIcon from './../../img.svg';

const PurchaseOrderDetail = () => {
  let params = useParams();
  const [show, setShow] = useState(false);
  const [purchaseOrderDetail, setPurchaseOrderDetail] = useState('');
  const [quotationDetail, setQuotationDetail] = useState('');
  const [vehicleRequestDetail, setVehicleRequestDetail] = useState('');
  const formFields = {
    registrationNumber: '',
    charges: '',
    description: '',
    onRoadDate: '',
    location: '',
    userManual: null,
    userManualName: '',
    warranty: false,
    warrantyDate: '',
    driverName: '',
    driverMobile: '',
    driverAddress: '',
    referenceName: '',
    referenceMobile: '',
    status: 'ON ROAD',
    warrantyDocument: null,
    warrantyDocumentName: '',
    bill: null,
    billName: '',
    vehicleImage1: null,
    vehicleImageName1: '',
    vehicleImage2: null,
    vehicleImageName2: '',
    vehicleImage3: null,
    vehicleImageName3: '',
  };
  const [purchaseOrderForm, setPurchaseOrderForm] = useState(formFields);
  const [documentShowConfirmModel, setDocumentShowConfirmModel] = useState(false);
  const handleCloseDocumentConfirmModal = () => {
    setDocumentShowConfirmModel(false);
  };
  const [fieldToDeleted, setFieldToDeleted] = useState('');
  const [purchaseDocumentShowConfirmModel, setPurchaseDocumentShowConfirmModel] = useState(false);
  const handleClosePurchaseDocumentConfirmModal = () => {
    setPurchaseDocumentShowConfirmModel(false);
  };
  const [purchaseFieldToDeleted, setPurchaseFieldToDeleted] = useState('');
  const clickToDownload = useRef(null);
  const [invalidFileType, setInvalidFileType] = useState(false);

  let navigate = useNavigate();
  const handleToggle = (e) => {
    const { checked } = e.target;
    setPurchaseOrderForm({ ...purchaseOrderForm, warranty: checked });
  };

  const handleShowDocumentConfirmModal = (e, field) => {
    e.preventDefault();
    setDocumentShowConfirmModel(true);
    setFieldToDeleted(field);
  };
  const handleShowPurchaseDocumentConfirmModal = (e, field) => {
    e.preventDefault();
    setPurchaseDocumentShowConfirmModel(true);
    setPurchaseFieldToDeleted(field);
  };

  const handleClose = () => {
    setShow(false);
  };
  const handleShow = () => {
    setShow(true);
  };

  const handleChange = (e) => {
    e.preventDefault();
    let name = e.target.name;
    let value = e.target.value;
    setPurchaseOrderForm({ ...purchaseOrderForm, [name]: value });
  };

  const onChangeManual = (e) => {
    e.preventDefault();
    const file = e.target.files[0];
    if (file && file.name.match(/\.(exe|apk|bat|cmd|com|dll|jar|msi|py|sh)$/)) {
      e.target.value = ''; // Clear the selected file
      toast.error('Please select a valid file type.', { autoClose: 2000 });
    } else {
      setPurchaseOrderForm({ ...purchaseOrderForm, userManual: file || null, userManualName: file?.name || '' });
    }
  };

  const onChangeWarrantyDocument = (e) => {
    e.preventDefault();
    const file = e.target.files[0];
    if (file && file.name.match(/\.(exe|apk|bat|cmd|com|dll|jar|msi|py|sh)$/)) {
      e.target.value = ''; // Clear the selected file
      toast.error('Please select a valid file type.', { autoClose: 2000 });
    } else {
      setPurchaseOrderForm({ ...purchaseOrderForm, warrantyDocument: file || null, warrantyDocumentName: file?.name || null });
    }
  };
  const onChangeBill = (e) => {
    e.preventDefault();
    const file = e.target.files[0];
    if (file && file.name.match(/\.(exe|apk|bat|cmd|com|dll|jar|msi|py|sh)$/)) {
      e.target.value = ''; // Clear the selected file
      toast.error('Please select a valid file type.', { autoClose: 2000 });
    } else {
      setPurchaseOrderForm({ ...purchaseOrderForm, bill: file || null, billName: file?.name || null });
    }
  };
  const onChangeVehicleImage1 = (e) => {
    e.preventDefault();
    const file = e.target.files[0];
    if (file && file.name.match(/\.(exe|apk|bat|cmd|com|dll|jar|msi|py|sh)$/)) {
      e.target.value = ''; // Clear the selected file
      toast.error('Please select a valid file type.', { autoClose: 2000 });
    } else {
      setPurchaseOrderForm({ ...purchaseOrderForm, vehicleImage1: file || null, vehicleImageName1: file?.name || null });
    }
  };
  const onChangeVehicleImage2 = (e) => {
    e.preventDefault();
    const file = e.target.files[0];
    if (file && file.name.match(/\.(exe|apk|bat|cmd|com|dll|jar|msi|py|sh)$/)) {
      e.target.value = ''; // Clear the selected file
      toast.error('Please select a valid file type.', { autoClose: 2000 });
    } else {
      setPurchaseOrderForm({ ...purchaseOrderForm, vehicleImage2: file || null, vehicleImageName2: file?.name || null });
    }
  };
  const onChangeVehicleImage3 = (e) => {
    e.preventDefault();
    const file = e.target.files[0];
    if (file && file.name.match(/\.(exe|apk|bat|cmd|com|dll|jar|msi|py|sh)$/)) {
      e.target.value = ''; // Clear the selected file
      toast.error('Please select a valid file type.', { autoClose: 2000 });
    } else {
      setPurchaseOrderForm({ ...purchaseOrderForm, vehicleImage3: file || null, vehicleImageName3: file?.name || null });
    }
  };

  useEffect(() => {
    getPurchaseOrder();
  }, []);

  const getPurchaseOrder = async () => {
    const PurchaseOrderVal = await getSinglePurchaseOrder(params.purchaseId);
    setPurchaseOrderDetail(PurchaseOrderVal.data);
  };

  useEffect(() => {
    if (purchaseOrderDetail !== '') {
      getSingleQuotation();
      getVR();
    }
  }, [purchaseOrderDetail]);

  const getSingleQuotation = async () => {
    const quotationVal = await getQuotationRequest(purchaseOrderDetail?.VehicleRequestId, purchaseOrderDetail?.QuotationId);
    setQuotationDetail(quotationVal.data);
  };

  const getVR = async () => {
    const vehicleRequest = await getVehicleRequest(purchaseOrderDetail?.VehicleRequestId);
    setVehicleRequestDetail(vehicleRequest.data);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (invalidFileType) {
      toast.error('Please select a valid file.', { autoClose: 2000 });
      return;
    }
    const formData = new FormData();
    for (var key in purchaseOrderForm) {
      if (
        key === 'userManual' ||
        key === 'userManualName' ||
        key === 'warrantyDocument' ||
        key === 'warrantyDocumentName' ||
        key === 'bill' ||
        key === 'billName' ||
        key === 'vehicleImage1' ||
        key === 'vehicleImageName1' ||
        key === 'vehicleImage2' ||
        key === 'vehicleImageName2' ||
        key === 'vehicleImage3' ||
        key === 'vehicleImageName3'
      )
        continue;
      formData.append(key, purchaseOrderForm[key]);
    }
    if (purchaseOrderForm.userManual !== null)
      formData.append('userManual', purchaseOrderForm['userManual'], purchaseOrderForm.userManualName);
    if (purchaseOrderForm.warrantyDocument !== null)
      formData.append('warrantyDocument', purchaseOrderForm['warrantyDocument'], purchaseOrderForm.warrantyDocumentName);
    if (purchaseOrderForm.bill !== null) formData.append('bill', purchaseOrderForm['bill'], purchaseOrderForm.billName);
    if (purchaseOrderForm.vehicleImage1 !== null)
      formData.append('vehicleImage1', purchaseOrderForm['vehicleImage1'], purchaseOrderForm.vehicleImageName1);
    if (purchaseOrderForm.vehicleImage2 !== null)
      formData.append('vehicleImage2', purchaseOrderForm['vehicleImage2'], purchaseOrderForm.vehicleImageName2);
    if (purchaseOrderForm.vehicleImage3 !== null)
      formData.append('vehicleImage3', purchaseOrderForm['vehicleImage3'], purchaseOrderForm.vehicleImageName3);
    formData.append('vehicleRequestId', vehicleRequestDetail?.id);
    formData.append('vehicleModelName', vehicleRequestDetail?.model);
    formData.append('purchaseOrderId', purchaseOrderDetail?.id);
    try {
      /** Creating running vechile */
      await createRunningVehicle(formData);
      toast.success('Running Vehicle added successfully');
      /** Updating purchase order */
      await updateStatusPurchaseOrder(purchaseOrderDetail?.id);
      getPurchaseOrder();
      setShow(false);
      /** Updating running vehicle status */
      await updateStatusRunningVehicle(vehicleRequestDetail?.id);
      getVR();
      navigate('/vm/running-vehicle');
    } catch (err) {
      toast.error(err?.response?.data?.data?.message || err?.message || 'Something went wrong', { autoClose: 3000 });
    }
  };

  const deletePurchaseOrderFile = (field) => {
    try {
      destroy(`/vm/vehicle-requests/purchaseorders/${purchaseOrderDetail.id}/filefrom/${field}`)
        .then((resp) => {
          setPurchaseDocumentShowConfirmModel(false);
          setPurchaseOrderDetail(resp.data);
        })
        .catch((error) => {
          toast.error(error.message);
        });
    } catch (e) {
      toast.error(e.message);
    }
  };
  const deleteQuotationFile = (field) => {
    try {
      destroy(`/vm/vehicle-requests/${vehicleRequestDetail.id}/quotations/${quotationDetail.id}/filefrom/${field}`)
        .then((resp) => {
          setDocumentShowConfirmModel(false);
          setQuotationDetail(resp.data);
        })
        .catch((error) => {
          toast.error(error.message);
        });
    } catch (e) {
      toast.error(e.message);
    }
  };

  const handleDownload = async (e, id) => {
    e.preventDefault();
    try {
      const data = await getSinglePurchaseOrderReport(id, vehicleRequestDetail.id);
      if (data.data) {
        clickToDownload.current.href = `${process.env.REACT_APP_BASE_URL}/file/download?filePath=` + data.data;
        setTimeout(() => {
          clickToDownload.current.click();
        }, 500);
      }
    } catch (err) {
      console.error(err);
      toast.error(err.message);
    }
  };

  return (
    <React.Fragment>
      <ToastContainer />
      <nav className="" aria-label="breadcrumb">
        <ol className="breadcrumb">
          <li className="breadcrumb-item">
            <Link to="/vm/purchase-orders">Purchase Order List</Link>
          </li>
          <li className="breadcrumb-item">
            <Link to={`/vm/purchase-orders/${purchaseOrderDetail.id}`}>Purchase Order Detail</Link>
          </li>
        </ol>
      </nav>
      <div className="card">
        <div className="card-header white-color" style={{ padding: '1rem 1.7rem' }}>
          <h4 className="card-title mb-0" style={{ fontSize: '16px' }}>
            Purchase Order Detail
          </h4>
          <a ref={clickToDownload} href="" target="_blank" className="hiddenItem">
            HiddenClick
          </a>
          <button type="button" onClick={(e) => handleDownload(e, purchaseOrderDetail.id)} className="btn app-btn-default dark-color">
            Download Report
          </button>
        </div>
        <div className="card-body">
          <Row className="top-row">
            <div className="col-md-2">
              <dd className="display-title mb-1">PO Number</dd>
              <dt className="display-value">{purchaseOrderDetail.purchaseNumber}</dt>
            </div>
            <div className="col-md-2">
              <dd className="display-title mb-1">Vehicle Name</dd>
              <dt className="display-value">{purchaseOrderDetail.vehicleName}</dt>
            </div>
            <div className="col-md-2">
              <dd className="display-title mb-1">Amount</dd>
              <dt className="display-value">{purchaseOrderDetail?.Quotation?.price}</dt>
            </div>
            <div className="col-md-2">
              <dd className="display-title mb-1">Approved By</dd>
              <dt className="display-value">{purchaseOrderDetail.approvedBy}</dt>
            </div>
            <div className="col-md-2">
              <dd className="display-title mb-1">Approved Date</dd>
              <dt className="display-value">{formatDate(purchaseOrderDetail?.approvedDate)}</dt>
            </div>
          </Row>
          <Row>
            <Col xs={4}>
              <h6>Downloads</h6>
              <ul className="list-group">
                {purchaseOrderDetail.file1 !== null ? (
                  <li className="list-group-item">
                    <Row>
                      <Col xs={8} className="file-name">
                        {purchaseOrderDetail.file1Name}
                      </Col>
                      <Col xs={4} className="text-end actions">
                        <a href={`${process.env.REACT_APP_BASE_URL}/file/download?filePath=${purchaseOrderDetail.file1}`}>
                          <DownloadIcon />
                        </a>
                        <DeleteIcon onClick={(e) => handleShowPurchaseDocumentConfirmModal(e, 'file1')} />
                      </Col>
                    </Row>
                  </li>
                ) : (
                  ''
                )}
                {purchaseOrderDetail.file2 !== null ? (
                  <li className="list-group-item">
                    <Row>
                      <Col xs={8} className="file-name">
                        {purchaseOrderDetail.file2Name}
                      </Col>
                      <Col xs={4} className="text-end actions">
                        <a href={`${process.env.REACT_APP_BASE_URL}/file/download?filePath=${purchaseOrderDetail.file2}`}>
                          <DownloadIcon />
                        </a>
                        <DeleteIcon
                          onClick={(e) => handleShowPurchaseDocumentConfirmModal(e, 'file2')}
                          style={{ color: 'rgb(220, 53, 69)', cursor: 'pointer' }}
                        />
                      </Col>
                    </Row>
                  </li>
                ) : (
                  ''
                )}
                {purchaseOrderDetail.file3 !== null ? (
                  <li className="list-group-item">
                    <Row>
                      <Col xs={8} className="file-name">
                        {purchaseOrderDetail.file3Name}
                      </Col>
                      <Col xs={4} className="text-end actions">
                        <a href={`${process.env.REACT_APP_BASE_URL}/file/download?filePath=${purchaseOrderDetail.file3}`}>
                          <DownloadIcon />
                        </a>
                        <DeleteIcon
                          onClick={(e) => handleShowPurchaseDocumentConfirmModal(e, 'file3')}
                          style={{ color: 'rgb(220, 53, 69)', cursor: 'pointer' }}
                        />
                      </Col>
                    </Row>
                  </li>
                ) : (
                  ''
                )}
              </ul>
            </Col>
            {purchaseOrderDetail.status === null ? (
              <Col xs={5}>
                <div className="btn-wrapper">
                  <button type="button" onClick={handleShow} className="btn app-btn-primary mt-5">
                    On Road
                  </button>
                </div>
              </Col>
            ) : (
              ''
            )}
          </Row>
        </div>
      </div>
      {quotationDetail ? (
        <div className="card">
          <div className="card-header white-color" style={{ padding: '1rem 1.7rem' }}>
            <h4 className="card-title mb-0" style={{ fontSize: '16px' }}>
              Quotation Detail
            </h4>
          </div>
          <div className="card-body">
            <Row className="top-row">
              <div className="col-md-2">
                <dd className="display-title mb-1">Vendor Name</dd>
                <dt className="display-value">{quotationDetail?.name}</dt>
              </div>
              <div className="col-md-2">
                <dd className="display-title mb-1">Price</dd>
                <dt className="display-value">{quotationDetail?.price}</dt>
              </div>
              <div className="col-md-2">
                <dd className="display-title mb-1">GST</dd>
                <dt className="display-value">{quotationDetail?.gst}</dt>
              </div>
              <div className="col-md-2">
                <dd className="display-title mb-1">Email</dd>
                <dt className="display-value">{quotationDetail?.email}</dt>
              </div>
              <div className="col-md-2">
                <dd className="display-title mb-1">Status</dd>
                <dt className="display-value">{quotationDetail?.status}</dt>
              </div>
              <div className="col-md-2">
                <dd className="display-title mb-1">Contact Person</dd>
                <dt className="display-value">{quotationDetail?.contactPerson}</dt>
              </div>
            </Row>
            <Row className="top-row">
              <div className="col-md-2">
                <dd className="display-title mb-1">Contact Number</dd>
                <dt className="display-value">{quotationDetail?.contact}</dt>
              </div>
              <div className="col-md-2">
                <dd className="display-title mb-1">Description</dd>
                <dt className="display-value">{quotationDetail?.description}</dt>
              </div>
            </Row>
            <Row>
              <Col xs={4}>
                <h6>Downloads</h6>
                <ul className="list-group">
                  {quotationDetail?.file1 !== null ? (
                    <li className="list-group-item">
                      <Row>
                        <Col xs={8} className="file-name">
                          {quotationDetail?.fileName1}
                        </Col>
                        <Col xs={4} className="text-end actions">
                          <a href={`${process.env.REACT_APP_BASE_URL}/file/download?filePath=${quotationDetail?.file1}`}>
                            <DownloadIcon />
                          </a>
                          <DeleteIcon onClick={(e) => handleShowDocumentConfirmModal(e, 'file1')} />
                        </Col>
                      </Row>
                    </li>
                  ) : (
                    ''
                  )}
                  {quotationDetail?.file2 !== null ? (
                    <li className="list-group-item">
                      <Row>
                        <Col xs={8} className="file-name">
                          {quotationDetail?.fileName2}
                        </Col>
                        <Col xs={4} className="text-end actions">
                          <a href={`${process.env.REACT_APP_BASE_URL}/file/download?filePath=${quotationDetail?.file2}`}>
                            <DownloadIcon />
                          </a>
                          <DeleteIcon onClick={(e) => handleShowDocumentConfirmModal(e, 'file2')} />
                        </Col>
                      </Row>
                    </li>
                  ) : (
                    ''
                  )}
                </ul>
              </Col>
            </Row>
          </div>
        </div>
      ) : (
        ''
      )}
      <div className="card">
        <div className="card-header white-color" style={{ padding: '1rem 1.7rem' }}>
          <h4 className="card-title mb-0" style={{ fontSize: '16px' }}>
            Vehicle Request Detail
          </h4>
        </div>
        <div className="card-body">
          <Row className="top-row">
            <div className="col-md-2">
              <dd className="display-title mb-1">Vehicle Name</dd>
              <dt className="display-value">{vehicleRequestDetail?.model}</dt>
            </div>
            <div className="col-md-2">
              <dd className="display-title mb-1">Requested Date</dd>
              <dt className="display-value">{formatDate(vehicleRequestDetail?.requestedDate)}</dt>
            </div>
            <div className="col-md-2">
              <dd className="display-title mb-1">Status</dd>
              <dt className="display-value">{vehicleRequestDetail?.status}</dt>
            </div>
            <div className="col-md-2">
              <dd className="display-title mb-1">Requested By</dd>
              <dt className="display-value">{vehicleRequestDetail?.requestedBy}</dt>
            </div>
            <div className="col-md-2">
              <dd className="display-title mb-1">Initiated By</dd>
              <dt className="display-value">{vehicleRequestDetail?.initiatedBy}</dt>
            </div>
            <div className="col-md-2">
              <dd className="display-title mb-1">Reason</dd>
              <dt className="display-value">{vehicleRequestDetail?.reason}</dt>
            </div>
          </Row>
        </div>
      </div>
      <Modal size="lg" show={show} backdrop="static" keyboard={false} className="request-modal">
        <Modal.Header>
          <Modal.Title>Add Running Vehicle</Modal.Title>
          <button type="button" className="btn-close" aria-label="Close" onClick={handleClose}></button>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Row>
              <Col xs={4}>
                <FloatingLabel controlId="floatingInput" label="Vehicle Model Name" className="mb-3">
                  <Form.Control
                    value={vehicleRequestDetail?.model}
                    className="input"
                    name="vehicleModelName"
                    type="text"
                    placeholder="Vehicle Model Name"
                    required
                    readOnly
                  />
                </FloatingLabel>
              </Col>
              <Col xs={4}>
                <FloatingLabel controlId="floatingInput" label="Registration Number" className="mb-3">
                  <Form.Control
                    onChange={handleChange}
                    value={purchaseOrderForm.registrationNumber}
                    className="input"
                    name="registrationNumber"
                    type="text"
                    placeholder="Enter Registration Number"
                    required
                  />
                </FloatingLabel>
              </Col>
              <Col xs={4}>
                <FloatingLabel controlId="floatingInput" label="Additional Charges" className="mb-3">
                  <Form.Control
                    onChange={handleChange}
                    value={purchaseOrderForm.charges}
                    className="input"
                    name="charges"
                    type="text"
                    placeholder="Enter Charges"
                    required
                  />
                </FloatingLabel>
              </Col>
            </Row>
            <Row>
              <Col xs={4}>
                <FloatingLabel controlId="floatingInput" label="Description" className="mb-3">
                  <Form.Control
                    onChange={handleChange}
                    value={purchaseOrderForm.description}
                    className="input"
                    name="description"
                    type="text"
                    placeholder="Description"
                  />
                </FloatingLabel>
              </Col>
              <Col xs={4}>
                <FloatingLabel controlId="floatingInput" label="On Road Date" className="mb-3">
                  <Form.Control
                    onChange={handleChange}
                    value={purchaseOrderForm.onRoadDate}
                    className="input"
                    name="onRoadDate"
                    type="date"
                    required
                  />
                </FloatingLabel>
              </Col>
              <Col xs={4}>
                <FloatingLabel controlId="floatingInput" label="Location" className="mb-3">
                  <Form.Control
                    onChange={handleChange}
                    value={purchaseOrderForm.location}
                    className="input"
                    name="location"
                    type="text"
                    placeholder="Location"
                    required
                  />
                </FloatingLabel>
              </Col>
            </Row>
            <Row className="mb-4">
              <Col xs={4}>
                <Form.Group controlId="formFile" className="mb-3 images-box">
                  <Form.Label className="label-text">User Manual</Form.Label>
                  <Form.Control onChange={onChangeManual} type="file" name="userManual" aria-required="false" />
                </Form.Group>
              </Col>
            </Row>
            <Row className="mb-4">
              <Col xs={12} className="blockLine my-3">
                <p className="my-0">
                  <strong>Warranty</strong>
                </p>
                <hr className="my-0" />
              </Col>
              <Col xs={5} className="warranty-btn mt-3">
                <span>Is Warranty Available?</span>
                <input
                  className="react-switch-checkbox"
                  id={`react-switch-new`}
                  type="checkbox"
                  onChange={handleToggle}
                  checked={purchaseOrderForm.warranty}
                  name="warranty"
                />
                <label className="react-switch-label" htmlFor={`react-switch-new`}>
                  <span className="no">NO</span>
                  <span className={`react-switch-button`} />
                  <span className="yes">YES</span>
                </label>
              </Col>
              {purchaseOrderForm.warranty === true ? (
                <Col xs={4} className="mt-4">
                  <FloatingLabel controlId="floatingInput" label="Warranty Covered Till" className="mt-1">
                    <Form.Control
                      onChange={handleChange}
                      value={purchaseOrderForm.warrantyDate}
                      className="input"
                      name="warrantyDate"
                      type="date"
                    />
                  </FloatingLabel>
                </Col>
              ) : (
                ''
              )}
            </Row>
            <Row className="mb-4">
              <Col xs={12} className="blockLine my-3">
                <p className="my-0">
                  <strong>Drivers details</strong>
                </p>
                <hr className="my-0" />
              </Col>
              <Col xs={4} className="mt-4">
                <FloatingLabel controlId="floatingInput" label="Driver Name">
                  <Form.Control
                    onChange={handleChange}
                    value={purchaseOrderForm.driverName}
                    className="input"
                    name="driverName"
                    type="text"
                    placeholder="Driver Name"
                    required
                  />
                </FloatingLabel>
              </Col>
              <Col xs={4} className="mt-4">
                <FloatingLabel controlId="floatingInput" label="Driver Mobile">
                  <Form.Control
                    onChange={handleChange}
                    value={purchaseOrderForm.driverMobile}
                    className="input"
                    name="driverMobile"
                    type="text"
                    placeholder="Driver Mobile"
                    required
                  />
                </FloatingLabel>
              </Col>
              <Col xs={4} className="mt-4">
                <FloatingLabel controlId="floatingInput" label="Driver Address">
                  <Form.Control
                    onChange={handleChange}
                    value={purchaseOrderForm.driverAddress}
                    className="input"
                    name="driverAddress"
                    type="text"
                    placeholder="Driver Address"
                  />
                </FloatingLabel>
              </Col>
            </Row>
            <Row className="mb-4">
              <Col xs={12} className="blockLine my-3">
                <p className="my-0">
                  <strong>Reference</strong>
                </p>
                <hr className="my-0" />
              </Col>
              <Col xs={4} className="mt-4">
                <FloatingLabel controlId="floatingInput" label="Reference Name" className="mb-3">
                  <Form.Control
                    onChange={handleChange}
                    value={purchaseOrderForm.referenceName}
                    className="input"
                    name="referenceName"
                    type="text"
                    placeholder="Reference Name"
                  />
                </FloatingLabel>
              </Col>
              <Col xs={4} className="mt-4">
                <FloatingLabel controlId="floatingInput" label="Reference Mobile" className="mb-3">
                  <Form.Control
                    onChange={handleChange}
                    value={purchaseOrderForm.referenceMobile}
                    className="input"
                    name="referenceMobile"
                    type="text"
                    placeholder="Reference Mobile"
                  />
                </FloatingLabel>
              </Col>
            </Row>
            <Row className="mb-3">
              <Col xs={12} className="blockLine my-3">
                <p className="my-0">
                  <strong>Documents</strong>
                </p>
                <hr className="my-0" />
              </Col>
              <Col xs={4} className="mt-4">
                <Form.Group controlId="formFile" className="mb-3 images-box">
                  <Form.Label className="label-text">Document 1</Form.Label>
                  <Form.Control onChange={onChangeWarrantyDocument} type="file" name="warrantyDocument" aria-required="false" />
                </Form.Group>
              </Col>
              <Col xs={4} className="mt-4">
                <Form.Group controlId="formFile" className="mb-3 images-box">
                  <Form.Label className="label-text">Document 2</Form.Label>
                  <Form.Control onChange={onChangeBill} type="file" name="bill" aria-required="false" />
                </Form.Group>
              </Col>
              <Col xs={4} className="mt-4">
                <Form.Group controlId="formFile" className="mb-3 images-box">
                  <Form.Label className="label-text">Document 3</Form.Label>
                  <Form.Control onChange={onChangeVehicleImage1} type="file" name="vehicleImage1" aria-required="false" />
                </Form.Group>
              </Col>
            </Row>
            <Row className="mb-4">
              <Col xs={4}>
                <Form.Group controlId="formFile" className="mb-3 images-box">
                  <Form.Label className="label-text">Document 4</Form.Label>
                  <Form.Control onChange={onChangeVehicleImage2} type="file" name="vehicleImage2" aria-required="false" />
                </Form.Group>
              </Col>
              <Col xs={4}>
                <Form.Group controlId="formFile" className="mb-3 images-box">
                  <Form.Label className="label-text">Document 5</Form.Label>
                  <Form.Control onChange={onChangeVehicleImage3} type="file" name="vehicleImage3" aria-required="false" />
                </Form.Group>
              </Col>
            </Row>
            <Button onClick={handleSubmit} type="submit" className="add-request-btn mt-4 mb-3 justify-content-center">
              Add
            </Button>
          </Form>
        </Modal.Body>
      </Modal>
      <Modal size="sm" show={documentShowConfirmModel} backdrop="static" keyboard={false} className="request-modal">
        <Modal.Header className="bg-danger text-light py-2">
          <Modal.Title>Delete Quotation Document</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="d-flex justify-content-start">
            <img src={AlertIcon} alt="Alert" />
            <p className="ps-3 mb-0">Are you sure? Action cannot be undone.</p>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <div className="btn-wrapper">
            <button onClick={handleCloseDocumentConfirmModal} className="btn app-btn-default btn-sm">
              Cancel
            </button>
            <button onClick={() => deleteQuotationFile(fieldToDeleted)} className="btn app-btn-danger btn-sm">
              Delete
            </button>
          </div>
        </Modal.Footer>
      </Modal>
      <Modal size="sm" show={purchaseDocumentShowConfirmModel} backdrop="static" keyboard={false} className="request-modal">
        <Modal.Header className="bg-danger text-light py-2">
          <Modal.Title>Delete Purchase Order Document</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="d-flex justify-content-start">
            <img src={AlertIcon} alt="Alert" />
            <p className="ps-3 mb-0">Are you sure? Action cannot be undone.</p>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <div className="btn-wrapper">
            <button onClick={handleClosePurchaseDocumentConfirmModal} className="btn app-btn-default btn-sm">
              Cancel
            </button>
            <button onClick={() => deletePurchaseOrderFile(purchaseFieldToDeleted)} className="btn app-btn-danger btn-sm">
              Delete
            </button>
          </div>
        </Modal.Footer>
      </Modal>
    </React.Fragment>
  );
};

export default PurchaseOrderDetail;
